import './Itinerary.css'

import { useState, useEffect } from 'react';
import Navbar from '../components/Navbar'
import Event from '../components/Event'
import { URL } from '../components/constants';

export default function Itinerary() {
  const [events, setEvents] = useState({});
  const [registeredEvents, setRegisteredEvents] = useState(new Set());
  const [userDetails, setUserDetails] = useState(null);
  const [loading, setLoading] = useState(true);

  function getDayOfWeek(dateStr) {
    const [month, day] = dateStr.split("/");
    const d = new Date(2026, month - 1, day); // year doesn't matter much
    return d.toLocaleDateString("en-US", { weekday: "long" });
  }

  useEffect(() => {
    async function fetchData() {
      try {
        // Fetch user info
        const meRes = await fetch(`${URL}/me`, { credentials: "include" });
        if (meRes.status !== 200) throw new Error("Failed to fetch user");
        const meData = await meRes.json();
        setUserDetails(meData.details);

        // Fetch all events
        const eventsRes = await fetch(`${URL}/allevents`, { credentials: "include" });
        if (eventsRes.status !== 200) throw new Error("Failed to fetch events");
        const eventsData = await eventsRes.json();
        setEvents(eventsData);

        // Fetch registered events for the user
        const regRes = await fetch(`${URL}/registered_events`, { credentials: "include" });
        if (regRes.status !== 200) throw new Error("Failed to fetch registered events");
        const regData = await regRes.json();
        setRegisteredEvents(new Set(regData));

      } catch (err) {
        console.error(err);
        setEvents({});
        setRegisteredEvents(new Set());
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, []);

  if (loading) return <div><Navbar /></div>;

  // Handle join/leave updates
  const handleRegistrationChange = (eventId, registered) => {

    // Update registered event set
    setRegisteredEvents(prev => {
      const updated = new Set(prev);
      if (registered) updated.add(eventId);
      else updated.delete(eventId);
      return updated;
    });

    // Update avatars in events list
    setEvents(prev => {
      const updated = { ...prev };
      const event = { ...updated[eventId] };

      const users = event.users_registered ? [...event.users_registered] : [];

      if (registered) {
        if (!users.some(u => u.nickname === userDetails.nickname)) {
          users.push({
            nickname: userDetails.nickname,
            image: userDetails.image
          });
        }
      } else {
        event.users_registered = users.filter(
          u => u.nickname !== userDetails.nickname
        );
        updated[eventId] = event;
        return updated;
      }

      event.users_registered = users;
      updated[eventId] = event;
      return updated;
    });
  };

  // Convert events object into array
  const eventsArray = Object.entries(events).map(([key, event]) => ({
    key,
    event,
    isRegistered: registeredEvents.has(key)
  }));

  // Sort events by date
  eventsArray.sort((a, b) => a.event.order - b.event.order);

  return (
    <div>
      <Navbar />
      <div className={"itinerary-body"}>
        <div className={"events"}>
          <h1>group itinerary</h1>
          <i>All times in NZ timezone</i><br/><br />
          Please register for optional events that you would like to attend. <br/>
          You can see your events in <a href="/hobbithole"> Home</a>. <br/>
          <br/>

          {eventsArray.map(({ key, event, isRegistered }, index) => {
            const currentDate = event.start_time_nz.split(" ")[0];

            let showDateHeader = false;

            if (index === 0) {
              showDateHeader = true;
            } else {
              const prevDate = eventsArray[index - 1].event.start_time_nz.split(" ")[0];
              showDateHeader = currentDate !== prevDate;
            }

            return (
              <div key={key}>
                {showDateHeader && (
                  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <h3>{getDayOfWeek(currentDate)} — {currentDate}</h3>
                    <hr style={{ flex: 1, border: "none", borderTop: "4px solid #ADB68C" }} />
                  </div>
                )}

                <Event
                  id={key}
                  name={event.title}
                  startTime={event.start_time_nz}
                  endTime={event.end_time_nz}
                  description={event.description}
                  location={event.place}
                  mandatory={event.mandatory}
                  register={event.register}
                  initial_registered={isRegistered}
                  registeredUsers={event.users_registered}
                  onRegistrationChange={handleRegistrationChange}
                />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}